import React, { useContext } from 'react';
import { FaPlus, FaCheck, FaPen, FaFileSignature } from 'react-icons/fa';
import theme from 'v3/theme';
import { formatDateTime } from 'v3/utils/formatter';
import { Text } from 'v3/components';
import { validatePermission } from 'actions';
import { UserContext } from 'contexts/UserContext';
import { IconButton } from '../styles';
import { ActionButtonsContainer } from './styles';

export function ActionButtons({
  show,
  setShow,
  selectedOccurrence,
  setSelectedOccurrence,
  setStartDate,
  setEndDate,
  loading,
  setOccurrenceValues,
  endLotOccurrenceModal,
  validOccurrencesConclusion,
}) {
  const { ...userContext } = useContext(UserContext);

  const hasPermissionaToAnnulOcurrence = validatePermission('ANULAR_OCORRENCIA');

  const canAnnul =
    userContext?.currentUser?.id === selectedOccurrence?.userCreated ||
    hasPermissionaToAnnulOcurrence;

  return (
    <ActionButtonsContainer>
      <IconButton
        iconColor={theme.colors.info}
        onClick={() => {
          setSelectedOccurrence({});
          setShow((old) => ({ ...old, addNewOccurrence: true }));
        }}
        disabled={show.addNewOccurrence || loading}
      >
        <FaPlus />
        <Text type="body" color="dark" weight="500">
          Inserir
        </Text>
      </IconButton>
      <IconButton
        iconColor={theme.colors.success}
        onClick={() => {
          setShow((old) => ({ ...old, lotOccurrence: true }));
          endLotOccurrenceModal.open();
        }}
        disabled={show.endLotOccurrence || loading || validOccurrencesConclusion}
      >
        <FaCheck />
        <Text type="body" color="dark" weight="500">
          Concluir em lote
        </Text>
      </IconButton>
      <IconButton
        iconColor={theme.colors.success}
        onClick={() => {
          setStartDate(formatDateTime(selectedOccurrence.startDate));
          setEndDate(
            selectedOccurrence.endDate ? formatDateTime(selectedOccurrence.endDate) : null,
          );
          setShow(old => ({ ...old, endOccurrence: true }));
          setOccurrenceValues({
            payCarrier: selectedOccurrence?.payCarrier,
            receiverClient: selectedOccurrence?.receiverClient,
            retainedBranch: selectedOccurrence?.retainedBranch,
          });
        }}
        disabled={
          (selectedOccurrence?.id && selectedOccurrence?.pendency === false) ||
          (selectedOccurrence?.id &&
            selectedOccurrence?.pendency === true &&
            selectedOccurrence?.userConclusion) ||
          Object.keys(selectedOccurrence).length === 0
        }
      >
        <FaCheck />
        <Text type="body" color="dark" weight="500">
          Concluir
        </Text>
      </IconButton>
      <IconButton
        iconColor={theme.colors.gray}
        disabled={
          (selectedOccurrence?.id && selectedOccurrence?.pendency === false) ||
          (selectedOccurrence?.id &&
            selectedOccurrence?.pendency === true &&
            selectedOccurrence?.userConclusion) ||
          Object.keys(selectedOccurrence).length === 0
        }
        onClick={() => {
          setShow((old) => ({ ...old, changeResponsible: true }));
        }}
      >
        <FaPen />
        <Text type="body" color="dark" weight="500">
          Alterar responsabilidade
        </Text>
      </IconButton>
      <IconButton
        iconColor={theme.colors.yellow_rating_star}
        disabled={
          (selectedOccurrence?.id && selectedOccurrence?.pendency === false) ||
          (selectedOccurrence?.id &&
            selectedOccurrence?.pendency === true &&
            selectedOccurrence?.userConclusion) ||
          Object.keys(selectedOccurrence).length === 0
        }
        onClick={() => {
          setStartDate(formatDateTime(selectedOccurrence.startDate));
          setEndDate(
            selectedOccurrence.endDate ? formatDateTime(selectedOccurrence.endDate) : null,
          );
          setShow((old) => ({
            ...old,
            addDescriptionToOccurrence: true,
          }));

          setOccurrenceValues({
            payCarrier: selectedOccurrence?.payCarrier,
            receiverClient: selectedOccurrence?.receiverClient,
            retainedBranch: selectedOccurrence?.retainedBranch,
          });
        }}
      >
        <FaFileSignature />
        <Text type="body" color="dark" weight="500">
          Adicionar descrição
        </Text>
      </IconButton>
      <IconButton
        iconColor={theme.colors.info}
        onClick={() => {
          setShow((old) => ({
            ...old,
            annulOcurrence: true,
          }));
        }}
        disabled={
          show.addNewOccurrence ||
          loading ||
          selectedOccurrence.annulled ||
          !('annulled' in selectedOccurrence) ||
          !canAnnul
        }
      >
        <Text type="body" color="red" weight="500">
          Ø Anular
        </Text>
      </IconButton>
    </ActionButtonsContainer>
  );
}
